module.exports = __webpack_public_path__ + "static/media/personal_text_catalog.e03be8d7.xlsx";